import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/ixi-finance/')({
	beforeLoad: () => {
		throw redirect({ to: '/ixi-finance/manage-payments', replace: true });
	},
});
